import CircularProgress from '@mui/material/CircularProgress';
import LottieDefault, { LottieProps } from 'react-lottie';
import React from 'react';
import branclubloading from '../../../assets/lottie/brandclub_logo_load.json';
import EllipsisBlueLoading from '../../../assets/lottie/ellipsis_darkblue.json';
import EllipsisLoading from '../../../assets/lottie/ellipsis.json';
const Lottie = LottieDefault as React.ComponentType<LottieProps>;
const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: branclubloading,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const ellipsisBlueOptions = {
  loop: true,
  autoplay: true,
  animationData: EllipsisBlueLoading,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

const ellipsisOptions = {
  loop: true,
  autoplay: true,
  animationData: EllipsisLoading,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

interface LoadingProps {
  star?: boolean;
  ellipsis?: boolean;
  ellipsisBlue?: boolean;
  size?: number;
}

export const Loading = ({ star, ellipsisBlue, size, ellipsis }: LoadingProps) => {
  return (
    <div
      style={{
        position: 'relative',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
      }}
    >
      {ellipsisBlue ? (
        <Lottie options={ellipsisBlueOptions} isClickToPauseDisabled width={size ?? 30} height={size ?? 30} />
      ) : ellipsis ? (
        <Lottie options={ellipsisOptions} isClickToPauseDisabled width={size ?? 30} height={size ?? 30} />
      ) : star ? (
        <Lottie options={defaultOptions} width={200} />
      ) : (
        <CircularProgress size={100} />
      )}
    </div>
  );
};

export const ButtonLoadingEllipsis = ({ baseFontSize = 12, blue }: { baseFontSize?: number; blue?: boolean }) => {
  const ellipsisContainerSize = baseFontSize * 1.4;
  const ellipsisSize = baseFontSize * 2.6;
  const yOffset = ellipsisSize / 10;
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        width: ellipsisContainerSize,
        height: ellipsisContainerSize,
        minWidth: ellipsisContainerSize,
        minHeight: ellipsisContainerSize,
      }}
    >
      <div
        style={{
          position: 'absolute',
          width: ellipsisSize,
          height: ellipsisSize,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          transform: `translateY(${yOffset}px)`,
        }}
      >
        <Loading ellipsis={!blue} ellipsisBlue={blue} size={ellipsisSize} />
      </div>
    </div>
  );
};
